import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/beta-setting.scss";
import { Button } from "components/common/button";

export const BetaSetting = (props) => (
  <div className={ styles.container }>
    <h1>Default UI</h1>
    <h3>Set your default UI - The new UI (this UI) or the old UI</h3>
    <DefaultUIToggle { ...props } />
  </div>
);

const DefaultUIToggle = ({ isBetaDefault, isUpdateDefaultInterfaceLoading, onUpdateDefaultInterface }) => {
  if (isBetaDefault) {
    return (
      <Button danger loading={ isUpdateDefaultInterfaceLoading } onClick={ () => onUpdateDefaultInterface(false) }>
        Set old UI as default
      </Button>
    );
  }
  return (
    <Button loading={ isUpdateDefaultInterfaceLoading } onClick={ () => onUpdateDefaultInterface(true) } primary>
      Set this UI as default!
    </Button>
  );
};

DefaultUIToggle.propTypes = {
  isBetaDefault: PropTypes.bool.isRequired,
  isUpdateDefaultInterfaceLoading: PropTypes.bool.isRequired,
  onUpdateDefaultInterface: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/beta-setting.jsx